import React from 'react';
import { styled } from 'styled-components';
import { Container, ImageContainer, InfoContainer } from './ShowInfo.styles';
import { TextPlaceholder } from '../../../components/Placeholder/TextPlaceholder';
import { AspectPlaceholder } from '../../../components/Teaser/Placeholder/AspectPlaceholder';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const ShowInfoPlaceholder = () => /*#__PURE__*/_jsxs(Container, {
  children: [/*#__PURE__*/_jsxs(InfoContainer, {
    children: [/*#__PURE__*/_jsx(BreadcrumbsPlaceholder, {
      width: 20
    }), /*#__PURE__*/_jsx(TitlePlaceholder, {
      width: 88
    }), /*#__PURE__*/_jsxs(DescriptionPlaceHolderContainer, {
      children: [/*#__PURE__*/_jsx(TextPlaceholder, {
        width: 90
      }), /*#__PURE__*/_jsx(TextPlaceholder, {
        width: 94
      }), /*#__PURE__*/_jsx(TextPlaceholder, {
        width: 92
      }), /*#__PURE__*/_jsx(TextPlaceholder, {
        width: 76
      })]
    })]
  }), /*#__PURE__*/_jsx(ImageContainer, {
    children: /*#__PURE__*/_jsx(AspectPlaceholder, {
      aspectRatio: 16 / 9
    })
  })]
});
const BreadcrumbsPlaceholder = styled(TextPlaceholder).withConfig({
  displayName: "ShowInfoPlaceholder__BreadcrumbsPlaceholder",
  componentId: "sc-12rbwhd-0"
})(["height:24px;"]);
const TitlePlaceholder = styled(TextPlaceholder).withConfig({
  displayName: "ShowInfoPlaceholder__TitlePlaceholder",
  componentId: "sc-12rbwhd-1"
})(["height:36px;"]);
const DescriptionPlaceHolderContainer = styled.div.withConfig({
  displayName: "ShowInfoPlaceholder__DescriptionPlaceHolderContainer",
  componentId: "sc-12rbwhd-2"
})(["width:100%;"]);